import { defineMessages } from 'react-intl'

const scope = `procurify.accounts-payable.features.attach-invoice-to-matched-items.views.MatchedItemPicker`

export default defineMessages({
  instructions: {
    id: `${scope}.instructions`,
    defaultMessage: 'Select the matched items to attach this invoice to.',
  },
  selectItemAriaLabel: {
    id: `${scope}.selectItemAriaLabel`,
    defaultMessage: 'Select {description}',
  },
})
